import VueRouter from 'vue-router';

const router = new VueRouter({
  mode: 'history',

  routes: [
    {
      name: 'blog',
      path: '/:langcode?/blog'
    },
    {
      name: 'case-studies',
      path: '/:langcode?/design/inspiration/case-studies'
    },
    {
      name: 'compliance',
      path: '/:langcode?/resources/product-resources/compliances-certifications/:compliance'
    },
    {
      name: 'literature',
      path: '/:langcode?/resources/downloads/literature'
    },
    {
      name: 'masterspec',
      path: '/:langcode?/resources/product-resources/masterspec'
    },
    {
      name: 'press-releases',
      path: '/:langcode?/company/news-press/press-room/press-releases'
    },
    {
      name: 'product-configurator-viewer',
      path: '/:langcode?/commercial-bathroom-products/:product_type/browse'
    },
    {
      name: 'product-type',
      path: '/:langcode?/commercial-bathroom-products/:product_type/:parameter?'
    },
    {
      name: 'product',
      path: '/:langcode?/commercial-bathroom-products/:product_type/:product_line?/:product_title'
    },
    {
      name: 'product-rebates',
      path: '/:langcode?/sustainability/sustainability-resources/product-rebates'
    },
    {
      name: 'spec-finder',
      path: '/:langcode?/spec-finder'
    },
    {
      name: 'technical-downloads',
      path: '/:langcode?/resources/downloads/technical-downloads'
    },
    {
      name: 'green-product-finder',
      path: '/:langcode?/sustainability/tools/green-product-finder'
    },
    {
      name: 'sustainability-calculator',
      path: '/:langcode?/sustainability/tools/sustainability-calculator/:step?'
    },
    {
      name: 'videos',
      path: '/:langcode?/resources/product-resources/videos'
    }
  ]
});

export default router;
